import React from "react";
import { connect } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import { withCookies } from "react-cookie";
import { withRouter } from "react-router-dom";
import Loader from "dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent";

import Actions from "./Actions/Creators";
import Phi from "./Phi/Phi";
import Role from "./Phi/PhiRole";
import history from "./history";
import Constants from "./Phi/Constants";

// import App from './Containers/AppContainer';
import App from "./Containers/AppScreen";
import Auth from "./Containers/AuthContainer";

import Dashboard from "./Containers/DashboardContainer";
import Content from "./Containers/ContentContainer";
import MedicalHistory from "./Containers/MedicalHistoryContainer";
import CovidDeclaration from "./Containers/CovidDeclarationContainer";
import Resources from './Containers/ResourcesContainer'
import CovidDeclarationList from "./Containers/CovidDeclarationListContainer";
import CovidStats from './Containers/CovidStatsContainer'
import Support from './Containers/SupportContainer'

import Unauthenticated from "./Containers/UnauthenticatedContainer";

// import { LinkedInPopUp } from 'react-linkedin-login-oauth2';

class Routes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isMagicLink: this.props.location.pathname.match("/magic-link"),
            isInvitationLink: this.props.location.pathname.match("/invitation-link"),

            allowInvitationRequest: false,

            guestLoggedIn: false,
        };
    }

    // Lifecycle Methods

    render() {
        return (
            <section className="root-container">
                {this.isAuthenticated() ? (
                    <Switch>
                        <App>
                            {/* <Route path="/dashboard" component={Dashboard} /> */}
                            {/* <Route path="/content" component={Content} /> */}
                            {/* <Route path="/medical-history" component={MedicalHistory} /> */}
                            <Route path="/covid-declaration" component={CovidDeclaration} />
                            <Route path="/my-declaration" component={CovidDeclarationList} />
                            <Route path="/resources" component={Resources} />
                            <Route path="/covid-stats" component={CovidStats} />
                            <Route path="/support" component={Support} />

                            <Redirect to="/covid-declaration" />
                        </App>
                    </Switch>
                ) : (
                    <Switch>
                        <Unauthenticated>
                            <Route path="/login" component={Auth}/>

                            <Redirect to="/login" />
                        </Unauthenticated>
                    </Switch>
                )}
            </section>
        );
    }

    componentDidMount() {
        if (this.state.isMagicLink) {
            let magicLink = this.props.location.pathname.match("/magic-link/(.*)")[1].split("/");
            this.props.loginUsingMagicLink(magicLink[0], magicLink[1]);
        } else if (this.state.isInvitationLink) {
            if (!Phi.User.isGuest()) {
                this.props.loginGuest();
            }
            let invitationLink = this.props.location.pathname.match("/invitation-link/(.*)")[1].split("/");
            this.props.loginUsingInvitationLink(invitationLink[0], this.props.cookies);
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.user.isMagicLinkUsed && newProps.user.isMagicLinkSuccess !== this.props.isMagicLinkSuccess && !newProps.user.isMagicLinkSuccess && !this.state.guestLoggedIn) {
            this.setState({ guestLoggedIn: true, isMagicLink: false });
            newProps.loginGuest();
        }
        // if (newProps.user.isInvitationLinkUsed && newProps.user.isInvitationLinkSuccess !== this.props.isInvitationLinkSuccess && !newProps.user.isInvitationLinkSuccess && !this.state.guestLoggedIn && !newProps.user.allowInvitationLinkUpdate) {
        //     this.setState({ guestLoggedIn: true, isInvitationLink: false });
        //     newProps.loginGuest();
        // }
        // if (newProps.location.pathname !== this.props.location.pathname && newProps.location.pathname.match("/magic-link/(.*)") ){

        //     this.props.setLoader()
        //     let magicLink = newProps.location.pathname.match("/magic-link/(.*)")[1].split("/");
        //     this.props.loginUsingMagicLink(magicLink[0], magicLink[1], {hideForgotPassword: true});
        // }
    }

    isAuthenticated() {
        if (this.props.location.pathname.match('/magic-link')) {
            return this.isAuthenticatedMagicLink();
        } else {
            return this.isAuthenticatedNormal();
        }
    }

    loginResponse(cookies, token) {
        let authStatus;

        let roles = cookies.get("roles");
        let profile = cookies.get("profile");
        let custom = cookies.get("custom");
        let data = cookies.get("data");

        if (Boolean(roles) && Boolean(profile)) {
            Phi.Storage.setItem("roles", JSON.stringify(roles));
            roles = roles.map((a) => new Role(a));
            Phi.User.userRoles = roles;

            Phi.Storage.setItem("profile", JSON.stringify(profile));
            Phi.User.userProfile = profile;

            Phi.Storage.setItem("custom", JSON.stringify(custom));

            Phi.Storage.setItem("data", JSON.stringify(data));

            Phi.setSession(token);

            this.props.loginResponse({
                ok: true,
                error: false,
                message: "Already Logged In",
                profile: JSON.stringify(profile),
                custom: JSON.stringify(custom),
                data: JSON.stringify(data),
            });

            if (this.props.message === "Already Logged In") {
                authStatus = false;
            } else {
                authStatus = true;
            }
        }
    }

    isAuthenticatedInvitationLink() {
        let isAuthenticated = Phi.User.isAuthenticated();

        if (!isAuthenticated) {
            let authStatus = false;

            const cookies = this.props.cookies;

            let token = cookies.get("token");
            if (Boolean(token) && Boolean(token.jwt)) {
                authStatus = this.loginResponse(cookies, token);
            }

            return authStatus;
        } else if (this.props.user.isLoading) return false;
        return false;
    }

    isAuthenticatedMagicLink() {
        let isAuthenticated = Phi.User.isAuthenticated();

        if (!isAuthenticated) {
            let authStatus = false;

            const cookies = this.props.cookies;

            let token = cookies.get("token");
            if (Boolean(token) && Boolean(token.jwt)) {
                authStatus = this.loginResponse(cookies, token);
            }

            return authStatus;
        } else if (this.props.user.isLoading) return false;
        return false; // Change this if found regression #PersonalNote
    }

    isAuthenticatedNormal() {
        let isAuthenticated = Phi.User.isAuthenticated();
        let isGuest = Phi.User.isGuest();

        if (
            isAuthenticated &&
            this.props.user.isAuthenticated &&
            this.props.user.guestUser &&
            !this.state.isMagicLink && 
            !isGuest
        ) {
            return true;
        }

        if (isGuest) {
            return false;
        }

        if (!isAuthenticated) {
            let authStatus = false;

            const cookies = this.props.cookies;

            let token = cookies.get("token");
            if (Boolean(token) && Boolean(token.jwt)) {
                authStatus = this.loginResponse(cookies, token);
            }

            if (!authStatus && !this.props.user.isLoading && !this.state.isMagicLink && !this.state.guestRequestMade) {
                this.props.loginGuest();
                this.setState({guestRequestMade: true})
            }
            return authStatus;
        } else if (!this.props.user.isAuthenticated && !this.props.user.isLoading) {
            if (isGuest && !this.state.isMagicLink) {
                this.props.loginGuest();
            console.log('Magic Link')

                return false;
            } else {
                this.props.loginResponse({
                    ok: true,
                    error: false,
                    message: "Already Logged In",
                    profile: Phi.Storage.getItem("profile"),
                    custom: Phi.Storage.getItem("custom"), 
                    data: Phi.Storage.getItem("data"),
                });
            }
        } else if (isAuthenticated && !this.props.user.guestUser) return true;
        else return false

        // console.log('default')
        // console.log(isAuthenticated)
        // console.log(this.props.user.isAuthenticated)
        // console.log(isGuest)
        // console.log(this.props.user.guestUser)

        // return true;
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    loginGuest: () => dispatch(Actions.loginUser({}, {}, true)),
    loginResponse: (response) => dispatch(Actions.loginResponse(response)),
    loginUsingMagicLink: (magicLink, studentId, meta) => dispatch(Actions.loginUsingMagicLink(magicLink, studentId, meta)),
    loginUsingInvitationLink: (magicLink, cookies) => dispatch(Actions.loginUsingInvitationLink(magicLink, cookies)),

    setLoader: () => dispatch(Actions.setLoader())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withCookies(Routes)));
